import BaseStore from './BaseStore';
import _ from 'lodash';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

const defaultData = {
  id: null,
  firstname: '',
  lastname: '',
  phone: '',
  relationship: '',
  imgProfileUrl: null,
};
export class ContactPersonStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      data: _.cloneDeep(defaultData),
      contactPersons: [],
      contactDatas: [],
    });
  }

  setContactData(results) {
    let datas = [];
    if (results.length > 0) {
      datas = results.map((result) => {
        const list = {
          id: result.id || null,
          firstname: result.firstname || '',
          lastname: result.lastname || '',
          phone: result.phone || '',
          relationship: result.relationship || '',
          imgProfileUrl: result.imgProfileUrl || null,
          isValid: true,
        };
        return list;
      });
    } else {
      datas = [
        {
          id: null,
          firstname: '',
          lastname: '',
          phone: '',
          relationship: '',
          imgProfileUrl: null,
          isValid: true,
        },
      ];
    }

    this.contactDatas = datas;
  }

  setData(results) {
    let data = {};
    if (results.length > 0) {
      data = {
        id: results[0].id,
        firstname: results[0].firstname && results[0].firstname !== 'null' ? results[0].firstname : '',
        lastname: results[0].lastname && results[0].lastname !== 'null' ? results[0].lastname : '',
        phone: results[0].phone && results[0].phone !== 'null' ? results[0].phone : '',
        relationship: results[0].relationship,
      };
    } else {
      data = {
        id: null,
        firstname: '',
        lastname: '',
        phone: '',
        relationship: '',
      };
    }

    this.data = data;
  }

  changeMultiData(key, value, index) {
    this.contactDatas[index][key] = value;
  }

  changeData(key, value) {
    this.data[key] = value;
  }

  setContactPerson(datas) {
    this.contactDatas = datas;
  }

  async findContactPersonByPatientId(patientId) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/contactperson/${patientId}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        const data = res.body || {};
        if (data && data.contactPersons) {
          this.contactPersons = data.contactPersons;
          return data.contactPersons;
        }
        return [];
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateCurrentContact(patientId, data) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        contactPersons: data,
      };
      let url = `${config.api.url}/${config.api.version}/contactperson/update/current`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async create(data, patientId) {
    this.loading = true;
    try {
      const detail = {
        patientId,
        firstname: data.firstname,
        lastname: data.lastname,
        phone: data.phone,
        relationship: data.relationship,
      };
      let url = `${config.api.url}/${config.api.version}/contactperson`;
      const res = await rp
        .post(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async update(data) {
    this.loading = true;
    try {
      const detail = {
        firstname: data.firstname,
        lastname: data.lastname,
        phone: data.phone,
        relationship: data.relationship,
      };
      let url = `${config.api.url}/${config.api.version}/contactperson/${data.id}`;
      const res = await rp
        .put(url, {
          body: detail,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async delete(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/contactperson/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      console.log('error', err);
      throw err;
    } finally {
      this.loading = false;
    }
  }
}
export default new ContactPersonStore();
